var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticStyle:{"align-items":"center"},attrs:{"app":"","color":_vm.backgroundColor,"dark":_vm.dark}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("mdi-chevron-left")])],1),_c('v-toolbar-title',[_vm._v("Recent chats")]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }